import { Observable } from 'rxjs';

import { LoginProvider,SocialUser } from '@personal-area/global/social-authorization/models';

export abstract class BaseLoginProvider implements LoginProvider {
  public abstract initialize(): Observable<void>;

  public abstract signIn(): Observable<SocialUser>;

  protected _loadScript(
    id: string,
    src: string,
    parentElement: HTMLElement = null
  ): Observable<void> {
    // get document if platform is only browser
    return new Observable<void>(observer => {
      if (typeof document !== 'undefined' && !document.getElementById(id)) {
        const signInJS = document.createElement('script');

        signInJS.async = true;
        signInJS.src = src;
        signInJS.onload = () => {
          observer.next();
          observer.complete();
        };

        if (!parentElement) {
          parentElement = document.head;
        }

        parentElement.appendChild(signInJS);
      } else {
        observer.error();
      }
    })

  }
}
